import SpecialPlans from '@/components/PricingPlan/SpecialPlans'
import React from 'react'
import FeaturesTable from '../FeaturesTable'
import Faqs from '../Faqs'

const SMBPricingBlocks = () => {
  return (
    <>
      {' '}
      {/*  */}
      <SpecialPlans />
      <div className="h-12 md:h-20"></div>
      <FeaturesTable />
      <div className="max-w-3xl mx-auto  space-y-5 pt-20 pb-20">
        <div className=" border-t border-gray-200"></div>
        <h2 className="h2 text-center">How Does Tradly Pricing Work</h2>
        <ul className="max-w-3xl mx-auto pl-12 list-decimal space-y-1">
          <li>
            Base Cost shown above for the Hosted Backend. This includes the Tradly Headless API
            which stores your data and run your business operations. Hosting, Maintenace, Security
            and Updates.
          </li>
          <li>
            <p>+ Front end Templates.</p>
            <ul className="max-w-3xl mx-auto pl-12 list-disc mt-1">
              <li>A. Websites - Free Templates by Tradly or Paid Templates from Partners. </li>
              <li>
                B. Mobile Apps - Optionally you can buy app source code in Tradly Marketplace.
              </li>
            </ul>
          </li>

          <li>Optional Add Ons</li>
        </ul>
      </div>
      {/*  */}
      <Faqs />
    </>
  )
}

export default SMBPricingBlocks
